import React from "react"
import { useStyletron } from "baseui"

export const StyleCompat = () => {
    const [,theme] = useStyletron()
    return (
        <style>
            {`.error + .error {
                margin-left: 0.75rem;
            }`}
        {`.radioWidgetContainer > label { display: flex; align-items: center; color: ${theme.colors.primary};}`}
       {`.radioWidgetContainer input[type="radio"]:checked { border-color: ${theme.colors.tickFillSelected}}`}
    </style>
    )
}